export default __webpack_public_path__ + "static/media/phone-call-01 2.f60a7671.svg";